import { render, staticRenderFns } from "./ListaAsistencia.vue?vue&type=template&id=6b7d9791&scoped=true"
import script from "./ListaAsistencia.vue?vue&type=script&lang=js"
export * from "./ListaAsistencia.vue?vue&type=script&lang=js"
import style0 from "./ListaAsistencia.vue?vue&type=style&index=0&id=6b7d9791&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7d9791",
  null
  
)

export default component.exports